import { render, staticRenderFns } from "./startList.vue?vue&type=template&id=6902c476&scoped=true"
import script from "./startList.vue?vue&type=script&lang=js"
export * from "./startList.vue?vue&type=script&lang=js"
import style0 from "./startList.vue?vue&type=style&index=0&id=6902c476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6902c476",
  null
  
)

export default component.exports